import PropTypes from 'prop-types';
import { Heading, vars } from '@etg/wings';
import { css } from '@eti/styles';
import { TripDetailsWrapper, boundMargins } from './ItineraryComponents';
import ItineraryDateDurationInfo from './ItineraryDateDurationInfo';

const boundHeaderWrapperStyles = css`
  align-items: baseline;
  display: flex;
  justify-content: space-between;
  padding-block: 8px 16px;
`;

const dateWrapperStyles = css`
  background-color: #fff;
  border-radius: ${vars.card.borderRadius} ${vars.card.borderRadius} 0 0;
  margin-bottom: 4px;
`;

const totalDurationStyles = css`
  font-size: 0.875rem;
`;

const wrapperStyles = css`
  &::after {
    border-left: 1px dashed ${vars.colors.inputs.border};
    bottom: 0;
    ${boundMargins}
  }
`;

const spaceDivStyles = css`
  margin-bottom: 10px;
`;

const ItineraryBoundHeader = ({ calenderDate, title, totalDuration, shouldShowTitle = true }) => {
  return (
    <>
      {shouldShowTitle ? (
        <div className={boundHeaderWrapperStyles}>
          <Heading data-testid="tripDetails-date-title" level={3}>
            {title}
          </Heading>
          {totalDuration && (
            <p className={totalDurationStyles} data-testid="tripDetails-dateduration-duration">
              {totalDuration}
            </p>
          )}
        </div>
      ) : (
        <div className={spaceDivStyles} />
      )}
      <div className={dateWrapperStyles} data-testid="tripDetails-boundHeader">
        <TripDetailsWrapper className={wrapperStyles}>
          <ItineraryDateDurationInfo
            calenderDate={calenderDate}
            data-testid="tripDetails-boundHeader-duration"
          />
        </TripDetailsWrapper>
      </div>
    </>
  );
};

ItineraryBoundHeader.propTypes = {
  calenderDate: PropTypes.string,
  shouldShowTitle: PropTypes.bool,
  title: PropTypes.string,
  totalDuration: PropTypes.string,
};

export default ItineraryBoundHeader;
